/**
 * DEPRECATED: This module is deprecated. Use classes that extend and interact with the observers/Observable module.
 */
/** The name of the module */
export const name = 'Observer';
export default class Observer {
    /**
     * Register a callback function to be called when triggered by the observable
     *
     * @param callback Callback function to be executed
     * @param observable Observable to observe
     * @param eventName Optional event name to filter by
     */
    registerCallback(callback, observable, eventName = '') {
        observable.subscribe(callback.bind(this), eventName);
    }
}
